<template>
  <label 
    ref="$input"
    class="bear-time-select"
    spellcheck="false" 
    autocapitalize="false" 
    autocomplete="off"
    :style="style"
  >
    <el-time-select 
      class="hidden-select" 
      v-model="value" 
      start="08:00"
      step="00:10"
      end="19:00"
      @change="handleChange"
    />
    {{text}}
    <el-icon v-if="value" class="icon-date-close" @click="clearValue"><circle-close /></el-icon>
  </label>
</template>
<script>
import {CircleClose} from '@element-plus/icons-vue'
import utils from '../../common/js/utils'
export default {
  name: 'BearTimeSelect',
  components: {
    CircleClose
  },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    attrs: {
      type: Object,
      default() {
        return {}
      }
    },
    options: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    style() {
      let len = utils.getTextLength(this.modelValue)
      let {minWidth} = this.attrs
      if(len > 10) {
        return {
          minWidth: minWidth || '100px'
        }
      } else {
        return {
          display: 'inline-block',
          minWidth: minWidth || '100px'
        }
      }
    },
    text() {
      return this.value
    }
  },
  data() {
    return {
      value: ''
    }
  },
  methods: {
    handleChange() {
      this.$emit('update:modelValue', this.value)
      this.emitChange()
    },
    clearValue() {
      this.value = ''
      this.$emit('update:modelValue', '')
      this.emitChange()
    },
    emitChange() {
      this.$emit('change', this.value)
    }
  },
  watch: {
    modelValue(value) {
      this.value = value
    }
  }
}
</script>
<style lang="scss" scoped>
.bear-time-select {
  position: relative;
  z-index: 1;
  text-indent: 0;
  word-break: break-all;
  line-height: 1;
  padding: 5px 5px;
  width: auto;
  min-width: 100px;
  cursor: pointer;
  text-align: left;
  outline: none;
  color: #2393e4;
  border-bottom: 1px solid black;
}
.icon-date-close {
  float: right;
  color: #A8ABB2;
  vertical-align: text-bottom;
  cursor: pointer;
  &:hover {
    color:#2393e4;
  }
}
</style>
<style lang="scss">
.tender-form-item {
  .hidden-select {
    width: 0px !important;
    height: 16px;
    overflow: hidden;
    vertical-align: text-bottom;
  }
  .is-error {
    .bear-time-select {
      border-bottom: 1px solid red;
      &+.el-form-item__error {
        position: relative;
        display: inline;
        padding: 5px 5px;
        background: #efdede;
        border-bottom: 1px solid red;
        border-radius: 0 3px 0 0;
      }
    }
  }
}
</style>